import { type VerificationCodeReceiveInputType } from '@shelflix/schemas/authentication/verificationReceive';
import { create } from 'zustand';

interface VerificationReceiveFormStore {
  formData: Partial<VerificationCodeReceiveInputType>;
  setFormData: (data: Partial<VerificationCodeReceiveInputType>) => void;
  resetForm: () => void;
}

export const useVerificationReceiveStore = create<VerificationReceiveFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
